import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";

const initialState = {
    isLoading: false,
    error: null,
    orderlist: [],
    singleorder: null,
};

export const createOrder = createAsyncThunk(
    "orders/create_order",
    async (orderData, { dispatch, rejectWithValue }) => {
        try {
            const response = await axios.post(`orders/create_order.php`, orderData);
            return response?.data;
        } catch (error) {
            const message = error.response?.data?.message || error.response?.data?.error || error.message || "Failed to add order";
            return rejectWithValue(message);
        }
    }
);

export const getOrderData = createAsyncThunk(
    "order/get_order",
    async ({ userId }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(getOrderDataStart());
            const response = await axios.get(`orders/get_orders.php?user_id=${userId}`);
            dispatch(getOrderDataSuccess(response?.data));
            return response?.data;
        } catch (error) {
            dispatch(getOrderDataFailure(error.response?.data?.message || "Failed to fetch order"));
            return rejectWithValue(error.response?.data?.message || "Failed to fetch order");
        }
    }
);
export const getSingleOrderData = createAsyncThunk(
    "order/get_order",
    async ({ orderId }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(getSingleOrderDataStart());
            const response = await axios.get(`orders/get_single_order.php?order_id=${orderId}`);
            dispatch(getSingleOrderDataSuccess(response?.data));
            return response?.data;
        } catch (error) {
            dispatch(getSingleOrderDataFailure(error.response?.data?.message || "Failed to fetch order"));
            return rejectWithValue(error.response?.data?.message || "Failed to fetch order");
        }
    }
);

export const removeOrder = createAsyncThunk(
    "order/remove_order",
    async ({ user_id, order_id }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axios.post(`order/remove_from_order.php`, {
                user_id,
                order_id,
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to remove order");
        }
    }
);

export const updateOrder = createAsyncThunk(
    "order/update_order",
    async ({ order_id, orderData }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `order/update_order.php?id=${order_id}`,
                orderData
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to update order"
            );
        }
    }
);


const orderSlice = createSlice({
    name: 'orders',
    initialState,
    reducers: {
        getOrderDataStart(state, action) {
            state.isLoading = true;
            state.error = null;
            state.orderlist = [];
        },
        getOrderDataSuccess(state, action) {
            state.isLoading = false;
            state.singleorderlist = action.payload?.orders || [];
        },
        getOrderDataFailure(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },
        getSingleOrderDataStart(state, action) {
            state.isLoading = true;
            state.error = null;
            state.singleorder = [];
        },
        getSingleOrderDataSuccess(state, action) {
            state.isLoading = false;
            state.singleorder = action.payload;
        },
        getSingleOrderDataFailure(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createOrder.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createOrder.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(createOrder.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(updateOrder.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateOrder.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(updateOrder.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    }
});

export const {
    getOrderDataStart,
    getOrderDataSuccess,
    getOrderDataFailure,
    getSingleOrderDataStart,
    getSingleOrderDataSuccess,
    getSingleOrderDataFailure,
} = orderSlice.actions;

export default orderSlice.reducer;